import LoopingEllipsis from '@/components/LoopingEllipsis';
import { classes } from './utils';

export type TabMessageProps = {
  loading?: boolean;
  message: string;
};

export default function TabMessage({ loading, message }: TabMessageProps) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.message}>
        {message}
        {loading && <LoopingEllipsis />}
      </div>
    </div>
  );
}
